module.exports = __webpack_public_path__ + "img/tristar.ec3e440d.svg";